import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AuthService } from '../../../core/services/auth.service';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-tax-companion-floater',
  standalone: true,
  imports: [CommonModule, NzToolTipModule, SvgIconComponent],
  templateUrl: './tax-companion-floater.component.html',
  styleUrl: './tax-companion-floater.component.css',
})
export class TaxCompanionFloaterComponent {
  authService = inject(AuthService);
  router = inject(Router);
  isLoggedIn = this.authService.isLoggedInSignal;

  askTaxAI(): void {
    window.location.href = 'https://www.taxnigeria.com';
  }
}
